// Autogenerated file
export const userMessageTypesEnum = {
    User: "User",
    System: "System",
    BidStart: "BidStart",
    BidApproved: "BidApproved",
    DriverControlPoints: "DriverControlPoints",
    BidLateness: "BidLateness",
    BidPointLateness: "BidPointLateness",
    TrackerLogsStopped: "TrackerLogsStopped",
    CarStopped: "CarStopped",
    RouteEvents: "RouteEvents",
    AxisLoadMonitoring: "AxisLoadMonitoring",
    CarStaysAtBidPoint: "CarStaysAtBidPoint",
    BidAcceptLateness: "BidAcceptLateness",
    TemperatureMonitoring: "TemperatureMonitoring",
    BidRefuelingPointArrival: "BidRefuelingPointArrival",
    BidPlannedRefuelings: "BidPlannedRefuelings",
    RefuelingSkipped: "RefuelingSkipped",
    PointVisiting: "PointVisiting",
    LoadLateness: "LoadLateness",
    ServicePoints: "ServicePoints",
    Waybills: "Waybills",
    EmergencyAreaVisit: "EmergencyAreaVisit",
    DocumentStatus: "DocumentStatus",
    DocumentFile: "DocumentFile",
    RouteControlPoints: "RouteControlPoints",
};
export const userMessageTypes = [
    { label: "Пользовательский", value: "User" },
    { label: "Системный", value: "System" },
    { label: "Запуск заявки", value: "BidStart" },
    { label: "Заявка была согласована", value: "BidApproved" },
    { label: "Уведомления по заданию водителям", value: "DriverControlPoints" },
    { label: "Опоздание по заявке", value: "BidLateness" },
    { label: "Прибытие на точку заявки не вовремя", value: "BidPointLateness" },
    { label: "Нет данных с трекеров машины более Х часов", value: "TrackerLogsStopped" },
    { label: "Машина стоит более Х часов в ходе выполнения заявки", value: "CarStopped" },
    { label: "Отклонение по маршруту", value: "RouteEvents" },
    { label: "Отклонения значений нагрузки на ось", value: "AxisLoadMonitoring" },
    { label: "Машина задерживается на точке больше планового времени выезда", value: "CarStaysAtBidPoint" },
    { label: "Водитель не принял заявку в течение 1 часа", value: "BidAcceptLateness" },
    { label: "Отклонения по температурному режиму", value: "TemperatureMonitoring" },
    { label: "Прибытие/выезд из точки заправки", value: "BidRefuelingPointArrival" },
    { label: "Планирование заправок", value: "BidPlannedRefuelings" },
    { label: "Пропуск заправок", value: "RefuelingSkipped" },
    { label: "Посещение точек", value: "PointVisiting" },
    { label: "Прогноз опоздания на загрузку", value: "LoadLateness" },
    { label: "Точки сервисных работ", value: "ServicePoints" },
    { label: "ЭПД", value: "Waybills" },
    { label: "Посещение аварийного участка", value: "EmergencyAreaVisit" },
    { label: "Статус по документу", value: "DocumentStatus" },
    { label: "Файл документа", value: "DocumentFile" },
    { label: "Контроль планового маршрута", value: "RouteControlPoints" },
];
